import connect from 'components/shared/connect'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import React, { Component } from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import PrecedentsAdminContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/PrecedentsAdminContainer'
import { map } from 'rxjs/operators'

@connect(
  ({ view, sectionId, aol }) =>
    requestSectionPrecedents(view === 'browse' ? 'precedents' : view, sectionId, aol)
      .pipe(map(response => ({ response })))
)
class ConnectedPrecedentsAdmin extends Component {
  render () {
    return (
      <ResponseConsumer
        response={this.props.response}
        content={() => <PrecedentsAdminContainer {...this.props} />}
      />
    )
  }
}

export default ConnectedPrecedentsAdmin
